<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    filters-title="Ricerca tipi di analisi"
    results-title="Tipi di analisi"
    no-results-message="Nessun tipo di analisi trovato"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <analysis-type-filters v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-col v-for="r in page.content" sm="6" md="4">
        <router-link
          class="text-dark"
          style="text-decoration: none;"
          :to="{ name: 'AnalysisType', params: { id: r.id } }">
          <b-card>
            <!--
            <div slot="header" class="font-weight-bold">
              {{ r.id }}
            </div>
            -->
            {{ r.title || '&lt;Nessun titolo&gt;' }}
          </b-card>
        </router-link>
      </b-col>
    </b-row>
    <div slot="bottom-buttons" class="text-right mb-2">
      <b-button variant="success" :to="{ name: 'AnalysisType', params: { id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import AnalysisTypeService from 'app/services/AnalysisTypeService';
import FindPageMixin from 'vue-core/mixins/FindPageMixin';

export default {
  mixins: [ FindPageMixin ],

  created() {
    this.service = AnalysisTypeService;
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Tipi di analisi'
        }
      ];
    },

    sorters() {
      return [
        {
          label: 'Titolo',
          path: 'title'
        },
      ];
    }
  }
}
</script>
